import { Page } from 'components/shared/Page/Page';
import { TrailUgcProvider } from 'components/trailUgc/TrailUgcContext';
import type { Context } from 'types/Context';
import type Review from '@alltrails/shared/types/review';
import { Photo } from 'types/Photo';
import LocationServerData from 'types/LocationServerData';
import TrailUgc from '../TrailUgc';
import ItemTotals from '../types/ItemTotals';
import RatingsBreakdown from '../types/RatingsBreakdown';

type TrailUgcWrapperProps = {
  avgRating: number;
  context: Context;
  locationServerData: LocationServerData;
  ratingsBreakdown: RatingsBreakdown;
  reviews: {
    meta: {
      status: string;
      items: number;
      timestamp: string;
    };
    trail_reviews: Review[];
  };
  photos: Photo[];
  itemTotals: ItemTotals;
  section: 'LIST_PAGE';
};

const TrailUgcWrapper = (props: TrailUgcWrapperProps) => {
  const { avgRating, context, reviews, photos, itemTotals, ...remainingProps } = props;
  return (
    <Page context={context}>
      <TrailUgcProvider
        ugcInfo={{
          reviews: reviews.trail_reviews,
          photos,
          itemTotals
        }}
      >
        <TrailUgc avgRating={String(avgRating)} context={context} {...remainingProps} />
      </TrailUgcProvider>
    </Page>
  );
};

export default TrailUgcWrapper;
